import { api } from "./client";

export function getCrawlerSummary(brandId, { signal } = {}) {
  return api(`/api/crawler/summary?brand_id=${encodeURIComponent(brandId)}`, { signal });
}
